import {createInputFieldComponent, IInputFieldBusinessLogic, IInputFieldProperties} from '@vfde-brix/input-field';
import {IFormSelectionControlItemProperties} from '@vfde-brix/form-selection-control';
import {REQUIRED_VALIDATION_CONFIG} from '../constant';
import {
    NO_PATTERN_BUSINESS_LOGIC,
    required,
    minLength,
    maxLength,
    onlyNumbers,
    email,
} from '@vfde-brix/core';
import {
    INPUT_FIRSTNAME_ID,
    INPUT_LASTNAME_ID,
    INPUT_EMAIL_ID,
    INPUT_PHONE_ID,
    INPUT_COMPANY_ID,
    INPUT_ZIPCODE_ID,
    INPUT_CITY_ID,
    INPUT_STREET_ID,
    INPUT_HOUSE_NUMBER_ID,
} from '../constant';

/**
 * Input Field BRIX component
 * Title
 *
 */
export const mountInputFieldRadioTitle = (target: HTMLElement, onChange) => {
    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: required,
                errorKey: 'required',
            },
        ],
    };

    const items: IFormSelectionControlItemProperties[] = [
        {
           txtLabelText: '<p>Frau</p>',
           stdValue: 'Frau',
           stdID: 'title1',
        },
        {
            txtLabelText: '<p>Herr</p>',
            stdValue: 'Herr',
            stdID: 'title2',
        },
    ];

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-selection-control',
        containerInput: {
            stdGroupName: 'Customer-title',
            optType: 'radio',
            items,
            business: {
                onChange,
            },
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};

/**
 * Input Field BRIX component
 * Firstname
 *
 */
export const mountInputFieldFirstname = (target: HTMLElement, onChange) => {
    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: maxLength,
                errorKey: 'required',
                maxLength: 30,
            },
        ],
    };

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-text-input',
        containerInput: {
            stdId: INPUT_FIRSTNAME_ID,
            stdName: INPUT_FIRSTNAME_ID,
            optType: 'text',
            stdValue: '',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        containerLabel: {
            stdFor: INPUT_FIRSTNAME_ID,
            txtText: 'Vorname',
            business: {},
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};

/**
 * Input Field BRIX component
 * Lastname
 *
 */
export const mountInputFieldLastname = (target: HTMLElement, onChange) => {
    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: maxLength,
                errorKey: 'required',
                maxLength: 30,
            },
        ],
    };

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-text-input',
        containerInput: {
            stdId: INPUT_LASTNAME_ID,
            stdName: INPUT_LASTNAME_ID,
            optType: 'text',
            stdValue: '',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        containerLabel: {
            stdFor: INPUT_LASTNAME_ID,
            txtText: 'Nachname',
            business: {},
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};

/**
 * Input Field BRIX component
 * E-Mail
 *
 */
export const mountInputFieldEmail = (target: HTMLElement, onChange) => {
    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: email,
                errorKey: 'email',
            },
        ],
    };

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-text-input',
        containerInput: {
            stdId: INPUT_EMAIL_ID,
            stdName: INPUT_EMAIL_ID,
            optType: 'text',
            stdValue: '',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        containerLabel: {
            stdFor: INPUT_EMAIL_ID,
            txtText: 'E-Mail-Adresse',
            business: {},
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};

/**
 * Input Field BRIX component
 * Phone
 *
 */
export const mountInputFieldPhone = (target: HTMLElement, onChange) => {
    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: maxLength,
                errorKey: 'required',
                maxLength: 30,
            },
        ],
    };

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-text-input',
        containerInput: {
            stdId: INPUT_PHONE_ID,
            stdName: INPUT_PHONE_ID,
            optType: 'text',
            stdValue: '',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        containerLabel: {
            stdFor: INPUT_PHONE_ID,
            txtText: 'Rückruf-Nummer',
            business: {},
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};

/**
 * Input Field BRIX component
 * Company
 *
 */
export const mountInputFieldCompany = (target: HTMLElement, onChange) => {
    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: required,
                errorKey: 'required',
                maxLength: 30,
            },
        ],
    };

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-text-input',
        containerInput: {
            stdId: INPUT_COMPANY_ID,
            stdName: INPUT_COMPANY_ID,
            optType: 'text',
            stdValue: '',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        containerLabel: {
            stdFor: INPUT_COMPANY_ID,
            txtText: 'Firmenname (optional)',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        // stdHelperText: (window as any).additionalPageOptions.optionalFieldText,
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};

/**
 * Input Field BRIX component
 * Zipcode
 *
 */
export const mountInputFieldZipcode = (target: HTMLElement, onChange) => {
    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: onlyNumbers,
                errorKey: 'onlyNumbersZipcode',
            },
            {
                validator: maxLength,
                errorKey: 'maxLengthZipcode',
                maxLength: 5,
            },
            {
                validator: minLength,
                errorKey: 'minLengthZipcode',
                minLength: 5,
            },
        ],
    };

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-text-input',
        containerInput: {
            stdId: INPUT_ZIPCODE_ID,
            stdName: INPUT_ZIPCODE_ID,
            optType: 'text',
            stdValue: '',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        containerLabel: {
            stdFor: INPUT_ZIPCODE_ID,
            txtText: 'PLZ',
            business: {},
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);

};

/**
 * Input Field BRIX component
 * City
 *
 */
export const mountInputFieldCity = (target: HTMLElement, onChange) => {
    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: maxLength,
                errorKey: 'required',
                maxLength: 30,
            },
        ],
    };

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-text-input',
        containerInput: {
            stdId: INPUT_CITY_ID,
            stdName: INPUT_CITY_ID,
            optType: 'text',
            stdValue: '',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        containerLabel: {
            stdFor: INPUT_CITY_ID,
            txtText: 'Ort',
            business: {},
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};

/**
 * Input Field BRIX component
 * Street
 *
 */
export const mountInputFieldStreet = (target: HTMLElement, onChange) => {

    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: maxLength,
                errorKey: 'maxLengthStreet',
                maxLength: 50,
            },
        ],
    };

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-text-input',
        containerInput: {
            stdId: INPUT_STREET_ID,
            stdName: INPUT_STREET_ID,
            optType: 'text',
            stdValue: '',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        containerLabel: {
            stdFor: INPUT_STREET_ID,
            txtText: 'Stra&szlig;e',
            business: {},
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};

/**
 * Input Field BRIX component
 * House number
 *
 */
export const mountInputFieldHouseNumber = (target: HTMLElement, onChange) => {

    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: maxLength,
                errorKey: 'maxLengthHouseNumber',
                maxLength: 5,
            },
            {
                validator: minLength,
                errorKey: 'minLengthHouseNumber',
                minLength: 1,
            },
        ],
    };

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-text-input',
        containerInput: {
            stdId: INPUT_HOUSE_NUMBER_ID,
            stdName: INPUT_HOUSE_NUMBER_ID,
            optType: 'text',
            stdValue: '',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        containerLabel: {
            stdFor: INPUT_HOUSE_NUMBER_ID,
            txtText: 'Hausnummer',
            business: {},
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);

};

/**
 * Input Field BRIX component
 * checkbox list hous
 *
 */
export const mountCheckboxListHouse = (target: HTMLElement, onChange) => {
    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: required,
                errorKey: 'errorTextCheckbox',
            },
        ],
    };

    const items: IFormSelectionControlItemProperties[] = [
        {
           txtLabelText: '<p>Einfamilienhaus</p>',
           stdValue: 'einfamilienhaus',
           stdID: 'Einfamilienhaus',
        },
        {
            txtLabelText: '<p>Mehrfamilienhaus</p>',
            stdValue: 'mehrfamilienhaus',
            stdID: 'Mehrfamilienhaus',
        },
        {
            txtLabelText: '<p>Gewerbeobjekt</p>',
            stdValue: 'gewerbeobjekt',
            stdID: 'Gewerbeobjekt',
        },
    ];

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-selection-control',
        containerInput: {
            stdGroupName: 'house',
            optType: 'checkbox',
            items,
            business: {
                onChange,
            },
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};

/**
 * Input Field BRIX component
 * checkbox list hous
 *
 */
export const mountCheckboxListCustomerType = (target: HTMLElement, onChange) => {
    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: required,
                errorKey: 'errorTextCheckbox',
            },
        ],
    };

    const items: IFormSelectionControlItemProperties[] = [
        {
           txtLabelText: '<p>Privatkunden</p>',
           stdValue: 'privatkunden',
           stdID: 'Privatkunden',
        },
        {
            txtLabelText: '<p>Selbständige</p>',
            stdValue: 'selbstaendige',
            stdID: 'Selbständige',
        },
        {
            txtLabelText: '<p>Unternehmen</p>',
            stdValue: 'unternehmen',
            stdID: 'Unternehmen',
        },
    ];

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-selection-control',
        containerInput: {
            stdGroupName: 'customerType',
            optType: 'checkbox',
            items,
            business: {
                onChange,
            },
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};

/**
 * BRIX component
 * checkbox confirmation
 *
 */
export const mountCheckboxConfirmation = (target: HTMLElement, confirmationText, onChange) => {
    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: required,
                errorKey: 'required',
            },
        ],
    };

    const items: IFormSelectionControlItemProperties[] = [
        {
           txtLabelText: '<p>' + confirmationText + '</p>',
           stdValue: 'confirmation',
           stdID: 'Confirmation',
        },
    ];

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-selection-control',
        containerInput: {
            stdGroupName: 'Confirmation',
            optType: 'checkbox',
            items,
            business: {
                onChange,
            },
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};
